import axios from "axios";
import TipoPerfilEnum from "../../../enums/TipoPerfilEnum";

var url = process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/";
if (process.env.NODE_ENV === "development") {
  url = "https://localhost:5001/api/";
}

var aiUrl = url.replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiUrl = "http://localhost:8000/api/v1";
}

function _aiHeaders(token) {
  return { Authorization: "bearer " + token.token };
}

/* eslint-disable no-unused-vars */
export default {
  state: {
    status: "",
    emptyGuid: "00000000-0000-0000-0000-000000000000",
    baseURL: url,
    homologacao: url.includes("hml"),
    token: JSON.parse(localStorage.getItem("user-token")) || "",
    pmauHabilitado: null,
    pmauAdmin: null,
    // Módulos do PMAU liberados ao usuário na conta atual (ai-service /pmau-permissions/me).
    pmauModules: null
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
      // O login pode ser em outra conta (token expirado leva ao /login sem logout):
      // descarta o estado PMAU da anterior para ser recarregado.
      state.pmauHabilitado = null;
      state.pmauAdmin = null;
      state.pmauModules = null;
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.pmauHabilitado = null;
      state.pmauAdmin = null;
      state.pmauModules = null;
    },
    set_pmau_habilitado(state, value) {
      state.pmauHabilitado = value;
    },
    set_pmau_admin(state, value) {
      state.pmauAdmin = value;
    },
    set_pmau_modules(state, value) {
      state.pmauModules = value;
    }
  },
  actions: {
    login({ commit }, token) {
      return new Promise((resolve) => {
        localStorage.setItem("user-token", JSON.stringify(token));
        commit("auth_request");
        commit("auth_success", token);
        resolve();
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        localStorage.removeItem("user-token");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    setAutenticacao(auth) {
      localStorage.setItem("user-token", JSON.stringify(auth));
    },
    async fetchPmauAccess({ commit, state }) {
      const token = state.token;
      if (!token || !token.contaSelecionada || !token.token) {
        commit("set_pmau_habilitado", false);
        return;
      }
      try {
        const r = await axios.get(
          aiUrl + "/pmau-access/" + token.contaSelecionada.id,
          { headers: _aiHeaders(token) }
        );
        commit("set_pmau_habilitado", r.data.habilitado === true);
      } catch {
        commit("set_pmau_habilitado", false);
      }
    },
    // Admin PMAU + módulos liberados na conta atual, numa chamada só.
    async fetchPmauPermissions({ commit, state }) {
      const token = state.token;
      if (!token || !token.token) {
        commit("set_pmau_admin", false);
        commit("set_pmau_modules", []);
        return;
      }
      try {
        const r = await axios.get(
          aiUrl + "/pmau-permissions/me",
          { headers: _aiHeaders(token) }
        );
        commit("set_pmau_admin", r.data.pmau_admin === true);
        commit("set_pmau_modules", r.data.modules || []);
      } catch {
        commit("set_pmau_admin", false);
        commit("set_pmau_modules", []);
      }
    }
  },
  getters: {
    isLoggedIn: (state) => {
      if (!state.token || !state.token.dataExpiracao) {
        return false;
      }
      var dataExpiracao = new Date(state.token.dataExpiracao);
      var dataAtual = new Date();
      if (dataExpiracao <= dataAtual) return false;
      return true;
    },
    authStatus: (state) => state.status,
    getAutenticacao: (state) => state.token,
    getContaId: (state) => (state.token ? state.token.contaSelecionadaId : ""),
    getUsuarioId: (state) => (state.token ? state.token.usuarioId : ""),
    getPerfil: (state) => (state.token ? state.token.perfil : ""),
    getMensagem: (state) => state.mensagem,
    emptyGuid: (state) => state.emptyGuid,
    baseURL: (state) => state.baseURL,
    homologacao: (state) => state.homologacao,
    isUserSistema: (state) => {
      if (state.token) {
        return state.token.perfil == TipoPerfilEnum.Sistema;
      }
      return false;
    },
    isPmauHabilitado: (state) => state.pmauHabilitado === true,
    isPmauAdmin: (state) => state.pmauAdmin === true,
    // hasPmauModule("criar", "resultado") → true se tiver QUALQUER um dos módulos.
    hasPmauModule: (state) => (...codes) =>
      Array.isArray(state.pmauModules) && codes.some((c) => state.pmauModules.includes(c))
  },
  modules: {
    pessoa: {
      state: {
        vm: {}
      },
      mutations: {
        set_pessoa(state, obj) {
          state.vm = obj.vm;
        }
      }
    }
  }
};
